import script from "./ToggleButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ToggleButton.vue?vue&type=script&setup=true&lang=js"

import "./ToggleButton.vue?vue&type=style&index=0&id=4e5cbbb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e5cbbb5"]])

export default __exports__